import { Button, ButtonProps, styled } from "@mui/material";

export const GradientButton = styled(Button)<ButtonProps>(({ theme }) => ({
  background: "linear-gradient(45deg, #0adbe1AA, #fd8f02AA)",
  boxShadow: "-3px 3px 5px 2px #0adbe155, 3px 3px 5px 2px #fd8f0255",
  color: "#FFFFFFFF",
  paddingLeft: "30px",
  paddingRight: "30px",
}));
